@for (signatar of signatarer().interne; track signatar.medlem.id) {
  <moeteprotokoll-signatar [signatar]="signatar"
                           [medSigneringsstoette]="medSigneringsstoette()"
                           [moete]="moete()"
                           [protokollDokumentId]="protokollDokumentId()"
                           (vedSignert)="vedSignert.emit(signatar)"/>
}

@for (signatar of signatarer().eksterne; track $index) {
  <div class="signaturfelt ekstern" data-testid="signaturfelt">
    <div class="signatur"><!--eksterne deltakere kan ikke sign via lederplan - men signaturfeltet må være med da det opptar vertikal plass--></div>
    <div class="navn" data-testid="deltakernavn">{{ signatar.navn }}</div>
    <div class="rolle">{{ signatar.rolle }}</div>
    <div class="ekstern">{{ 'Ekstern'|translate }}</div>
  </div>
}
